/* OEST product page: looping carousel, variant → photo sync, sticky info offset, mobile bottom bar. */
(function () {
  function onScrollEnd(el, fn) {
    if ('onscrollend' in window) {
      el.addEventListener('scrollend', fn);
    } else {
      var t;
      el.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(fn, 120); }, { passive: true });
    }
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-oest-track]');
    var slides = Array.prototype.slice.call(track.children);
    var n = slides.length;
    var bars = root.querySelectorAll('.oest-carousel__bars span');
    if (n < 2) return null;

    // Clone last before first and first after last so scrolling past either end loops around.
    function makeClone(li) {
      var c = li.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('data-media-id');
      c.classList.add('is-clone');
      c.querySelectorAll('img').forEach(function (img) { img.loading = 'lazy'; img.removeAttribute('fetchpriority'); });
      return c;
    }
    track.insertBefore(makeClone(slides[n - 1]), slides[0]);
    track.appendChild(makeClone(slides[0]));

    var width = function () { return track.clientWidth; };
    var pos = function () { return Math.round(track.scrollLeft / width()); };
    function jump(i) {
      track.style.scrollSnapType = 'none';
      track.scrollTo({ left: i * width(), behavior: 'instant' });
      requestAnimationFrame(function () { track.style.scrollSnapType = ''; });
    }
    function go(i) { track.scrollTo({ left: i * width(), behavior: 'smooth' }); }
    function real(i) { return (i - 1 + n) % n; }
    function paint() {
      var r = real(pos());
      bars.forEach(function (b, k) { b.classList.toggle('is-active', k === r); });
    }

    jump(1);
    track.addEventListener('scroll', paint, { passive: true });
    onScrollEnd(track, function () {
      var p = pos();
      if (p === 0) jump(n);
      else if (p === n + 1) jump(1);
      paint();
    });
    root.querySelector('[data-oest-prev]').addEventListener('click', function () { go(pos() - 1); });
    root.querySelector('[data-oest-next]').addEventListener('click', function () { go(pos() + 1); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(pos() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(pos() + 1); }
    });
    var last = 1;
    track.addEventListener('scroll', function () { last = pos(); }, { passive: true });
    window.addEventListener('resize', function () { jump(last); });

    return {
      showMedia: function (mediaKey) {
        var idx = slides.findIndex(function (s) { return s.dataset.mediaId === mediaKey; });
        if (idx > -1) go(idx + 1);
      }
    };
  }

  // The info column's sticky top follows the bottom of the scroll-linked header (CSS uses
  // --oest-header-visible). If the column is taller than the screen, cap the top so its bottom stays reachable.
  function initStickyInfo(pdp) {
    var info = pdp.querySelector('.oest-pdp__info');
    if (!info) return;
    function update() {
      var gap = 24;
      pdp.style.setProperty('--pdp-fit-top', (window.innerHeight - info.offsetHeight - gap) + 'px');
    }
    update();
    window.addEventListener('resize', update);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(info);
  }

  function initBar(pdp) {
    var bar = document.querySelector('[data-oest-pdp-bar]');
    var submit = pdp.querySelector('.product-form__submit');
    if (!bar || !submit || !('IntersectionObserver' in window)) return;
    var btn = bar.querySelector('[data-oest-pdp-jump]');
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
    }).observe(submit);
    btn.addEventListener('click', function () {
      var picker = pdp.querySelector('variant-selects');
      if (picker) {
        picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var first = picker.querySelector('input:not(:disabled), select');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
      } else {
        submit.click();
      }
    });
  }

  function initPdp(pdp) {
    if (pdp.dataset.oestReady) return;
    pdp.dataset.oestReady = 'true';
    var carouselEl = pdp.querySelector('[data-oest-carousel]');
    var carousel = carouselEl ? initCarousel(carouselEl) : null;
    initStickyInfo(pdp);
    initBar(pdp);
    if (carousel && window.subscribe && window.PUB_SUB_EVENTS) {
      var productInfo = pdp.closest('product-info');
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (event) {
        var v = event && event.data && event.data.variant;
        if (!v || !v.featured_media || !productInfo || !document.contains(productInfo)) return;
        carousel.showMedia(productInfo.dataset.section + '-' + v.featured_media.id);
      });
    }
  }

  /* ---------- Colour family swap (separate products shown as colours, Satisfy-style) ----------
     Clicking a colour swatch fetches that product's section via the Section Rendering API and swaps it in place,
     keeping the selected size, updating the URL/title and supporting back/forward. No full page reload. */
  var swapCache = new Map();
  function sectionIdOf(root) {
    var pi = root.querySelector('product-info');
    return pi && pi.dataset.section;
  }
  function currentVariantTitle(root) {
    var el = root.querySelector('product-info [data-selected-variant]');
    try { return el ? JSON.parse(el.textContent).title : null; } catch (e) { return null; }
  }
  function targetUrl(tile, root) {
    var url = tile.dataset.productUrl;
    var map = {};
    try { map = JSON.parse(tile.dataset.variants || '{}'); } catch (e) {}
    var title = currentVariantTitle(root);
    var vid = title && map[title];
    return vid ? url + '?variant=' + vid : url;
  }
  function fetchSection(url, sectionId) {
    var req = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
    if (!swapCache.has(req)) {
      swapCache.set(req, fetch(req, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      }).catch(function (err) { swapCache.delete(req); throw err; }));
    }
    return swapCache.get(req);
  }
  function swapTo(url, root, push) {
    var sectionId = sectionIdOf(root);
    if (!sectionId) { window.location.href = url; return; }
    root.classList.add('oest-swapping');
    return fetchSection(url, sectionId).then(function (htmlText) {
      var doc = new DOMParser().parseFromString(htmlText, 'text/html');
      var fresh = doc.getElementById('shopify-section-' + sectionId) || doc.querySelector('.shopify-section');
      if (!fresh) throw new Error('section missing');
      root.innerHTML = fresh.innerHTML;
      var pi = root.querySelector('product-info');
      if (pi && pi.dataset.oestTitle) document.title = pi.dataset.oestTitle.replace(/&ndash;/g, '\u2013');
      if (push) history.pushState({ oestSwap: true }, '', url);
      root.querySelectorAll('.oest-pdp').forEach(initPdp);
      initColors(root);
    }).catch(function () {
      window.location.href = url;
    }).finally(function () {
      root.classList.remove('oest-swapping');
    });
  }
  // Quick, smooth return to the top when switching colour (~350ms ease-out; instant if reduced motion)
  function scrollToTop() {
    var start = window.scrollY;
    if (start <= 0) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { window.scrollTo(0, 0); return; }
    var duration = Math.min(450, 250 + start / 20);
    var t0 = performance.now();
    function frame(now) {
      var p = Math.min(1, (now - t0) / duration);
      var eased = 1 - Math.pow(1 - p, 3);
      window.scrollTo(0, Math.round(start * (1 - eased)));
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function initColors(root) {
    var picker = root.querySelector('[data-oest-colors]');
    if (!picker) return;
    picker.querySelectorAll('[data-oest-color]').forEach(function (tile) {
      var prefetch = function () {
        if (tile.classList.contains('is-active')) return;
        var sid = sectionIdOf(root);
        if (sid) fetchSection(targetUrl(tile, root), sid).catch(function () {});
      };
      tile.addEventListener('pointerenter', prefetch, { passive: true });
      tile.addEventListener('focus', prefetch);
      tile.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return; // allow open-in-new-tab
        e.preventDefault();
        if (tile.classList.contains('is-active')) return;
        scrollToTop();
        swapTo(targetUrl(tile, root), root, true);
      });
    });
  }

  function init() {
    document.querySelectorAll('.oest-pdp').forEach(initPdp);
    document.querySelectorAll('.oest-pdp').forEach(function (pdp) {
      var root = pdp.closest('.shopify-section');
      if (!root || root.dataset.oestColorsReady) return;
      root.dataset.oestColorsReady = 'true';
      initColors(root);
      history.replaceState({ oestSwap: true }, '', location.href);
      window.addEventListener('popstate', function () {
        // Back/forward between colours: swap if the URL now points at a different product than the one shown
        var pi = root.querySelector('product-info');
        if (pi && pi.dataset.url && pi.dataset.url !== location.pathname) swapTo(location.pathname + location.search, root, false);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
